export default __webpack_public_path__ + "static/media/bgnew.72d1ff71.png";